"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelDN = exports.getDNReducer = void 0;
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var usersList_1 = require("common/global/usersList");
var doesObjHaveUndefinedValues_1 = __importDefault(require("common/utils/doesObjHaveUndefinedValues"));
var removeUndefined_1 = __importDefault(require("common/utils/removeUndefined"));
var app_1 = __importStar(require("firebase/app"));
var set_1 = __importDefault(require("lodash/fp/set"));
var moment_1 = __importDefault(require("moment"));
var sendApprovalNotification_1 = require("portal/utils/sendApprovalNotification");
var SendNotification_1 = require("portal/utils/SendNotification");
var getDNReducer = function (router, t) { return function (state, action) {
    var _a, _b, _c, _d;
    var userId = (_b = (_a = (0, app_1.auth)().currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : "";
    switch (action.type) {
        case "init":
            return action.payload;
        case "update":
            if (action.payload.path === "DNData.deliveryDate") {
                // console.log(state?.POsData)
                if (state.POsData.PODate == undefined) {
                    // console.log({state})
                    var isBefore = (0, moment_1.default)(action.payload.newValue).isBefore((_c = state === null || state === void 0 ? void 0 : state.IRData) === null || _c === void 0 ? void 0 : _c.IRDate.toDate());
                    if (isBefore) {
                        antd_1.message.error("DN Date can not be before IR Date");
                    }
                    var newDate = isBefore
                        ? (_d = state === null || state === void 0 ? void 0 : state.IRData) === null || _d === void 0 ? void 0 : _d.IRDate
                        : action.payload.newValue; //TODO: check toDate()
                    return (0, set_1.default)(action.payload.path, newDate, state);
                }
                else {
                    var isBefore = (0, moment_1.default)(action.payload.newValue).isBefore(state.POsData.PODate.toDate());
                    if (isBefore) {
                        antd_1.message.error("DN Date can not be before PO Date");
                    }
                    var newDate = isBefore
                        ? state.POsData.PODate.toDate()
                        : action.payload.newValue;
                    return (0, set_1.default)(action.payload.path, newDate, state);
                }
            }
            return (0, set_1.default)(action.payload.path, action.payload.newValue, state);
        case "buttonClick":
            switch (action.data.action) {
                case "Approve": {
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0: return [4 /*yield*/, collectionsRef_1.approvalsRef.doc().set({
                                        approvedAt: action.data.payload.approvedAt,
                                        createdAt: new Date(),
                                        updatedAt: new Date(),
                                        userId: userId,
                                        formId: state.DNId,
                                        formType: "delivery-note",
                                        approvalType: action.data.payload.approvalType,
                                        signatureURL: (_b = (_a = usersList_1.globalUsersData[userId]) === null || _a === void 0 ? void 0 : _a.signatureURL) !== null && _b !== void 0 ? _b : "",
                                    })];
                                case 1:
                                    _c.sent();
                                    return [4 /*yield*/, checkIfAllApproved(state.DNId, state.DNData.orderId, state, userId, action.data.payload.approvalType, transaction)];
                                case 2:
                                    _c.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () {
                        antd_1.message.success(t("alerts.success"));
                    })
                        .then(function () {
                        //   window.location.reload();
                    });
                    var nextStatus = checkNextStatus(action.data.payload.approvalType);
                    return __assign(__assign({}, state), { DNData: __assign(__assign({}, state.DNData), { status: nextStatus }) });
                }
                case "Save": {
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        var dnData;
                        return __generator(this, function (_a) {
                            dnData = getDNDataFromState(state);
                            transaction.update(collectionsRef_1.DNsRef.doc(state.DNId), (0, removeUndefined_1.default)(dnData));
                            state.DNItems.map(function (DNItemDoc) {
                                var itemData = getItemDataFromItemState(DNItemDoc);
                                transaction.update(collectionsRef_1.DNItemsRef.doc(itemData.id), (0, removeUndefined_1.default)(itemData));
                            });
                            return [2 /*return*/];
                        });
                    }); })
                        .then(function () {
                        antd_1.message.success(t("alerts.success"));
                    })
                        .catch(function (e) {
                        console.error(e);
                        antd_1.message.error(t("alerts.error"));
                    });
                    break;
                }
                // case 'Revoke': {
                //     message.error(t('alerts.youcannot'))
                //     break
                // }
                case "Cancel": {
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, (0, exports.cancelDN)(state.DNId, transaction)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, (0, SendNotification_1.sendNotification)({
                                        warehouseId: state.DNData.warehouseId,
                                        projectId: state.DNData.projectId,
                                        docType: "delivery-note",
                                        docId: state.DNId,
                                        ref: (_a = state.DNData.DNNumber) !== null && _a !== void 0 ? _a : "",
                                        docDesc: "",
                                        action: "cancelled",
                                    })];
                                case 1:
                                    _b.sent();
                                    antd_1.message.success(t("alerts.success"));
                                    window.location.reload();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    break;
                }
                case "Publish": {
                    var DNData_1 = getDNDataFromState(state);
                    if ((0, doesObjHaveUndefinedValues_1.default)(DNData_1)) {
                        antd_1.message.error(t("alerts.invalidFormMsg"));
                        return __assign(__assign({}, state), { triedSubmitting: true });
                    }
                    state.DNItems.map(function (item) {
                        var itemData = getItemDataFromItemState(item);
                        if ((0, doesObjHaveUndefinedValues_1.default)(itemData)) {
                            antd_1.message.error(t("alerts.invalidFormMsg"));
                            return __assign(__assign({}, state), { triedSubmitting: true });
                        }
                    });
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!!(0, doesObjHaveUndefinedValues_1.default)(DNData_1)) return [3 /*break*/, 2];
                                    transaction.update(collectionsRef_1.DNsRef.doc(state.DNId), __assign({}, DNData_1));
                                    state.DNItems.map(function (item) {
                                        var itemData = getItemDataFromItemState(item);
                                        if (!(0, doesObjHaveUndefinedValues_1.default)(itemData)) {
                                            transaction.update(collectionsRef_1.DNItemsRef.doc(itemData.id), __assign({}, itemData));
                                        }
                                    });
                                    transaction.update(collectionsRef_1.DNsRef.doc(state.DNId), {
                                        status: "pendingDnReceivedAndCheckedByApproval",
                                        requestedAt: new Date(),
                                        requestedBy: app_1.default.auth().currentUser.uid,
                                    });
                                    return [4 /*yield*/, (0, sendApprovalNotification_1.sendApprovalNotification)({
                                            warehouseId: state.DNData.warehouseId,
                                            approval: "DNReceivedAndCheckedByApproval",
                                            projectId: state.DNData.projectId,
                                            amount: 0,
                                            docId: state.DNId,
                                            docType: "delivery-note",
                                            ref: state.DNData.DNNumber,
                                            userId: userId,
                                            docDesc: "",
                                            action: "approvalPending",
                                        })];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/, __assign(__assign({}, state), { triedSubmitting: true })];
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, antd_1.message.success(t("alerts.success"))];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () {
                        window.location.reload();
                    })
                        .catch(function (e) {
                        console.error(e);
                        antd_1.message.error(t("alerts.error"));
                    });
                    break;
                }
            }
            break;
    }
    return state;
}; };
exports.getDNReducer = getDNReducer;
var getDNDataFromState = function (state) {
    var _a, _b;
    return __assign(__assign({}, state.DNData), { deliveryDate: (_b = (_a = state.DNData.deliveryDate) === null || _a === void 0 ? void 0 : _a.toDate()) !== null && _b !== void 0 ? _b : undefined, DNNumber: state.DNData.DNNumber });
};
var getItemDataFromItemState = function (item) {
    return __assign(__assign({}, item), { orderedQuantity: item.orderedQuantity });
};
function checkIfAllApproved(DNId, orderId, state, userId, approvalType, transaction) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var waitingFor, order, ir;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, collectionsRef_1.ordersRef.doc(state.DNData.orderId).get()];
                case 1:
                    order = (_b.sent()).data();
                    return [4 /*yield*/, collectionsRef_1.IRsRef.doc(order.IRId).get()];
                case 2:
                    ir = (_b.sent()).data();
                    if (!(approvalType === "approvedBy")) return [3 /*break*/, 5];
                    transaction.update(collectionsRef_1.DNsRef.doc(DNId), { status: "approved" });
                    transaction.update(collectionsRef_1.ordersRef.doc(state.DNData.orderId), {
                        status: "postPOs",
                    });
                    return [4 /*yield*/, (0, SendNotification_1.sendNotification)({
                            warehouseId: state.DNData.warehouseId,
                            projectId: state.DNData.projectId,
                            docType: "delivery-note",
                            docId: state.DNId,
                            ref: (_a = state.DNData.DNNumber) !== null && _a !== void 0 ? _a : "",
                            docDesc: "",
                            action: "approved",
                        })];
                case 3:
                    _b.sent();
                    return [4 /*yield*/, Promise.all(state.DNItems.map(function (item) { return __awaiter(_this, void 0, void 0, function () {
                            var product;
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4 /*yield*/, collectionsRef_1.productsRef.doc((_a = item.orderedItem.id) !== null && _a !== void 0 ? _a : item.productId).get()];
                                    case 1:
                                        product = (_b.sent()).data();
                                        // await sendWarehouseNotification({
                                        //     approval: 'confirmReceiveFromDN',
                                        //     budgetLineId: ir.budgetLineId,
                                        //     productId: product.name,
                                        //     projectId: ir.projectId,
                                        //     quantity: item.receivedQuantity,
                                        //     stockNumber: '',
                                        //     warehouseId: state.DNData.warehouseId,
                                        //     operation: 'Receive from DN',
                                        //     docType: 'receivedFromDN',
                                        //     type: 'confirm',
                                        //     docId: state.DNData.warehouseId,
                                        //     fromWarehouseId: state.DNData.DNNumber,
                                        //     toWarehouseId: state.DNData.warehouseId,
                                        // })
                                        return [2 /*return*/, transaction.set(collectionsRef_1.warehouseTransferOperationsRef.doc(), {
                                                cachedProductName: product.name,
                                                cachedProductDescription: item.offeredItem,
                                                cachedProductUnit: item.unitId,
                                                supplierName: state.DNData.supplierName,
                                                PONumber: state.DNData.PONumber,
                                                DNNumber: state.DNData.DNNumber,
                                                createdAt: new Date(),
                                                destinationType: "warehouse",
                                                fromWarehouseId: DNId,
                                                productId: item.productId,
                                                notes: "",
                                                projectId: state.DNData.projectId,
                                                budgetLineId: item.budgetLineId,
                                                cachedProductCategory: product.categoryId,
                                                quantity: item.receivedQuantity,
                                                sentAt: new Date(),
                                                shippingCompany: "",
                                                sourceType: "DN",
                                                status: "sent",
                                                toWarehouseId: state.DNData.warehouseId,
                                                waybillNumber: "",
                                                batchNumber: null,
                                                from: "DN",
                                                stockNumber: "",
                                                serialNumbers: "",
                                                assetsNumbers: "",
                                                expiryDate: null,
                                                unitPrice: item.unitPrice,
                                            })];
                                }
                            });
                        }); }))];
                case 4:
                    _b.sent();
                    return [3 /*break*/, 7];
                case 5:
                    transaction.update(collectionsRef_1.DNsRef.doc(DNId), {
                        status: "pendingDnApprovedByApproval",
                    });
                    waitingFor = "DNApprovedByApproval";
                    return [4 /*yield*/, (0, sendApprovalNotification_1.sendApprovalNotification)({
                            warehouseId: state.DNData.warehouseId,
                            approval: "DNApprovedByApproval",
                            projectId: state.DNData.projectId,
                            amount: state.POsData.overallTotal,
                            docId: DNId,
                            docType: "delivery-note",
                            ref: state.DNData.DNNumber,
                            userId: state.DNData.requestedBy,
                            docDesc: "",
                            action: "approvalPending",
                        })];
                case 6:
                    _b.sent();
                    _b.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    });
}
function checkNextStatus(approvalType) {
    var status;
    if (approvalType === "approvedBy") {
        status = "approved";
    }
    else {
        status = "pendingDnApprovedByApproval";
    }
    return status;
}
var cancelDN = function (DNId, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var data, _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0: return [4 /*yield*/, transaction.get(collectionsRef_1.DNsRef.doc(DNId))];
            case 1:
                data = (_e.sent()).data();
                if (data.status === "singedAndArchived" || data.status === "completed") {
                    throw new Error("you cannot delete singed form");
                }
                transaction.update(collectionsRef_1.DNsRef.doc(DNId), {
                    status: "cancelled",
                    requestedAt: app_1.default.firestore.FieldValue.delete(),
                    requestedBy: app_1.default.firestore.FieldValue.delete(),
                });
                _b = (_a = Promise).all;
                return [4 /*yield*/, collectionsRef_1.approvalsRef.where("formId", "==", DNId).get()];
            case 2: return [4 /*yield*/, _b.apply(_a, [(_e.sent()).docs.map(function (x) {
                        return transaction.delete(x.ref);
                    })])];
            case 3:
                _e.sent();
                _d = (_c = Promise).all;
                return [4 /*yield*/, collectionsRef_1.notificationsRef
                        .where("docId", "==", DNId)
                        .where("action", "==", "approvalPending")
                        .get()];
            case 4: return [4 /*yield*/, _d.apply(_c, [(_e.sent()).docs.map(function (x) { return transaction.delete(x.ref); })])];
            case 5:
                _e.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.cancelDN = cancelDN;
